import { CustomerInfoHm } from "../Customer/AddCustomer/data";
import CustomerInfo from "../Customer/CustomerDetail/components/Profile/components/CustomerInfo";
import { UserInfo, UserInfoSummary } from "../Customer/TeamManage/data";

//record-finished
export enum InquiryOnlineStatusEnum {
  'ONLINE',
  'OFFLINE'
};

export type InquiryType = 1 | 2 | 3;

export type InquiryOnlineStatus = keyof typeof InquiryOnlineStatusEnum;

export interface IRecordFinishedParams {
  current?: number;
  departmentId?: number;
  doctorId?: string;
  keyword?: string;
  pageSize?: number;
  selectTimeB?: string;
  selectTimeE?: string;
  type: InquiryType;
  module?: number;
};

export type OnlineInquiryAudioClick = {
  eid: string;
  hasClicked: boolean;
  id: number;
  imMsgId: number;
};

export type Business = {
  biz: string;
  id: string;
};

export type BaseUserInfo = {
  avatarUrl: string;
  gender: number;
  id: string;
  mobile: string;
  name: string;
  tenantId: string;
}

export type ImEndpoint = {
  eid: string;
  imId: string;
  tag: string;
}

export type ImMessage = {
  audioClick: OnlineInquiryAudioClick;
  biz?: Business;
  content: string;
  eid: string;
  id: string;
  imId: string;
  sender: BaseUserInfo;
  tag: string;
  timestamp: number;
  // 前端使用
  isNewMsg?: boolean;
};

export type ImMessageBox = {
  content: string;
  eid: string;
  imId: string;
  messageId: number;
  timestamp: number;
  unread: number;
}

export type OnlineInquiryDepartment = {
  id: number;
  name: string;
  tenantId: number;
};

export type OnlineInquiryFamilyInfo = {
  age: number;
  id: number;
  mobile: string;
  name: string;
  sex: string;
};

export enum OnlineInquiryStatusEnum {
  '待接诊' = 1,
  '咨询中' = 2,
  '已结束' = 3
};

export type OnlineInquiryStatus = 1 | 2 | 3;

export type OnlineInquiryRecord = {
  customerInfo?: CustomerInfoHm;
  department?: OnlineInquiryDepartment;
  endTime: string;
  evaluation: string;
  familyInfo?: OnlineInquiryFamilyInfo;
  fee: number;
  imMessageBox?: ImMessageBox;
  img: string;
  inquiryId: string;
  realConsultTime: number;
  startTime: string;
  status: OnlineInquiryStatus;
  submitTime: string;
  symptom: string;
  userInfo?: UserInfo;
  type: InquiryType;
};

export type OnlineInquirySetting = {
  consultLength: number;
  dayOffB: string;
  dayOffE: string;
  fee: number;
  id: number;
  workDay: string;
  workTimeB: string;
  workTimeE: string;
  type: InquiryType;
  module: InquiryType;
};

export type OnlineInquirySchedule = {
  doctor: UserInfoSummary[];
  id: number;
  restFlag: 1 | 0;
  visitDate: string;
  type: InquiryType;
  module: InquiryType;
};

export type OnlineInquiryScheduleParam = {
  doctor: string;
  endDate: string;
  exclude: boolean;
  restFlag: 1 | 0;
  startDate: string;
  type: InquiryType;
  module: InquiryType;
};

export type TaskMessageContent = {
  text: string;
};

export type TaskMessage = {
  biz: string;
  content?: TaskMessageContent;
  timestamp: number;
};

export type ImContentType = 'text' | 'audio' | 'image';
export type ImContent = {
  type: ImContentType;
  value: string;
};
